import * as React from 'react';

export type FeedbackData = {
  message: string;
  state: boolean;
  type: 'error' | 'warning' | 'info' | 'success';
  tracking_id?: string | null;
};

interface ContextProps {
  feedbackData: FeedbackData;
  setFeedbackData: (feedbackData: FeedbackData) => void;
}

export const FeedbackSnackbarContext = React.createContext<ContextProps>({
  feedbackData: { message: '', state: false, type: 'info', tracking_id: null },
  setFeedbackData: () => null
});

const FeedbackSnackbarProvider = ({ children }: { children: React.ReactNode }) => {
  const [feedbackData, setFeedbackData] = React.useState<FeedbackData>({
    message: '',
    state: false,
    type: 'info',
    tracking_id: null
  });

  const value = {
    feedbackData,
    setFeedbackData
  };

  return (
    <FeedbackSnackbarContext.Provider value={value}>{children}</FeedbackSnackbarContext.Provider>
  );
};

export default FeedbackSnackbarProvider;
